window.VjsUtility = (function(my){
    var self = my.View = {},
        TEMPLATE_BASE_URL = null,
        TEMPLATE_VERSION = Math.random();

    self.setTemplateBaseUrl = function(baseUrl){
        TEMPLATE_BASE_URL = baseUrl;
    }

    self.setTemplateVersion = function(version){
        TEMPLATE_VERSION = version;
    }

    self.extend = function(extendProperties){
        return VjsUtility.extend(self.View, extendProperties);
    }

    self.View = function() {};
    self.View.prototype = {
        /**
         *   @desc main endpoint for api data
         *   @type string or function that returns string
         */
        dataUrl: null,

        /**
         *  @desc params used in fetch call
         *  @type object
         */
        fetchParams: null,

        /**
         *  @desc fetch type used GET or POST
         *  @type string
         */
        fetchType: null,

        /**
         *  @desc responose data from the fetch call, after being parsed
         */
        responseData: null,

        /**
         *  @desc responose data from the fetch call, before being parsed
         */
        originalResponseData: null,

        /**
         *   @desc the id or class of the parent html element that view should go into
         *   should be overridden if used. Only here as reminder
         */
        parent: null, // Should be Overridden

        /**
         *   @desc insert type describes how to add items to the dom
         *       defaults to html, but can use append or prepend
         */
        insertType: "html",  //html, prepend, append

        /**
         *   @desc base url to the templates folder.
         *   @type string
         */
        templateBaseUrl: function(){
            return TEMPLATE_BASE_URL ? TEMPLATE_BASE_URL : "";
        },

        /**
         *   @desc url of the handlebars template
         *   @type string or function that returns string
         */
        templateUrl: null,

        /**
         *   @desc template versioning to be sure ajax gets new template
         *   @type string or int
         */
        templateVersion: function(){
            return TEMPLATE_VERSION;
        },

        /**
         *  @desc overwritable function inorder to parse the api response data
         *  @type function
         *  @return parsed data to be passed to template
         *  @param $data mixed
         */
        parse: null,

        /**
         *  @desc function called before the template is rendered
         *      and html is available in the DOM
         *      returning data does nothiing
         */
        before: null,

        /**
         *  @desc function called after template is rendered
         *      and html is available in the DOM
         *      returning data does nothing
         */
        after: null,

        /**
         *  @desc events object to be set when class is instantiated
         */
        events: {
            //example of click event
            //"click .some-class": "callThisCustomFunction"

        },
        //callThisCustomFunction: function(){}     -- add a function to be called when event triggered

        /**
         *   @desc fetches model data
         *   @param objParam - (optional) parameters of the data call
         *   @param type - (optional) what type of ajax call. defaults to get
         */
        fetch: function(objParam, type) {
            this.fetchParams = objParam;
            this.fetchType = type;
            if ((this.fetchType+"").toLowerCase() === "post") {
                $.post(this._buildUrl(), objParam)
                    .done(this._start.bind(this))
                    .fail(this._fail.bind(this));
            } else{
                var url = this._buildUrl(objParam);
                $.get(url)
                    .done(this._start.bind(this))
                    .fail(this._fail.bind(this));
            }
        },

        render: function(renderData) {
            if(!this.parent) throw new Error("View parent is not set");
            var that = this;

            //Test if responseData has been set
            //render function can be called directly with data
            if (!this.responseData) {
                this.responseData = renderData;
            }

            //Call before fetching and rendering the template
            if(typeof this.before === "function"){
                this.before.call(this, this.responseData);
            }

            //We cache templates on the Handlebars object
            //test if that templates object has been set yet
            Handlebars.templates = Handlebars.templates ? Handlebars.templates : {};

            //get the template Url
            var url = (typeof this.templateUrl === "function") ? this.templateUrl() : this.templateUrl;
            if(!url || url === "") return;

            //Test if Handlers template is cached
            if (Handlebars.templates[url]) {
                //call the rendering function with the compiled template
                this._renderHelper(Handlebars.templates[url]);

            } else{
                //template is not cached
                //fetch the template and pass compiled template to rendering function
                this._fetchTemplate(url, function(compiledTemplate) {
                    this._renderHelper(compiledTemplate);
                }.bind(this));
            }
        },

        /**
         *   @desc returns url with serialized params for different type of calls
         *   @param type - type of call
         *   @param objParam - (optional) parameters to add to url
         *   @return final url
         */
        _buildUrl: function(objParam) {
            var url = typeof this.dataUrl === "function" ? this.dataUrl.call(this) : this.dataUrl;
            return url + "?" + $.param(objParam || {});
        },

        /**
         *   @desc generic fail function for the ajax functions
         *   should be overridden if need custom failure handling
         */
        _fail: function(x, h, r) {
            console.log(x,h,r);
        },

        _start: function(data) {
            this.originalResponseData = data;
            this.responseData = (typeof this.parse === "function") ? this.parse(this.originalResponseData) : this.originalResponseData;
            this.render(this.responseData);
        },

        _renderHelper: function(compiledTemplate){
            //test if parent is a string, it will be assumed it is a jquery eligible string
            if (typeof this.parent === "string") {
                $(this.parent)[this.insertType](compiledTemplate({ items: this.responseData }));

            //test if parent is a function, it will assume the response is a jquery eligible string
            } else if(typeof this.parent === "function") {
                $(this.parent())[this.insertType](compiledTemplate({ items: this.responseData }));

            //test if parent is an objecct, it will be assumed {this.parent} is a jquery object
            } else if (typeof this.parent === "object"){
                this.parent[this.insertType](compiledTemplate({ items: this.responseData }));

            //if none then throw an error
            }else{
                throw new Error("View : _renderHelper : Parent element is not correct format.");
            }

            //call the after function with the response data
            //this is the end of the line
            if(typeof this.after === "function"){
                this.after.call(this, this.responseData);
            }
        },

        /**
         *  @desc fetches the template
         */
        _fetchTemplate: function(url, callback){
            var url = url;
            return $.ajax({
                url: ((this.templateBaseUrl) ? this.templateBaseUrl() + url : url ) + "?v=" + this.templateVersion(),
                async: true,
                dataType: "text"
            })
                .done(function(res){
                    //cache the Handlebars template
                    Handlebars.templates[url] = Handlebars.compile(res);

                    //pass compiled template to callback
                    callback(Handlebars.templates[url]);

                }.bind(this))
                .fail(function(x, h, r) {
                    throw new Error("Failed to load template `" + url + "`");
                });
        },

        //same items from controller
        //handles the setting of events
        _construct: function() {
            this._setEvents();
        },
        _setEvents: function() {
            var s,
                events = this.events,
                that = this;
            for (var items in events) {
                s = items.split(" ");

                if (s[0] === "scroll") {
                    $(window).off(s[0]);
                    $(window).on(s[0], { items: events[items], that: this }, function(e) {
                        //Passing Context
                        var that = e.data.that;
                        that[e.data.items](e);
                    });
                } else {
                    //Remove the same event before adding another
                    $("body").off(s[0], s[1]);
                    $("body").on(s[0], s[1], { items: events[items], that: this }, function(e) {
                        //Passing Context
                        var that = e.data.that;
                        that[e.data.items](e);
                    });
                }
            }
        },

        // /**
        //  *   @desc Build popup
        //  */
        // _popup: function(html) {
        // 	new VJS.Popup.init({
        // 		title: this.popupTitle,
        // 		content: html,
        // 		transition: this.transition ? this.transition : "",
        // 		focusReturn: this.focusReturn ? this.focusReturn : null,

        // 	});
        // },

        // /**
        //  *   @desc is Popup
        //  */
        // isPopup: false,

        // /**
        //  *   @desc Popup Title
        //  */
        // popupTitle: "VJS Popup",
    };

    return my;
}(window.VjsUtility || {}));
